import * as React from 'react';
import { Prompt, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps } from 'recompose';
import { reduxForm, getFormValues, FieldArray } from 'redux-form';
import { RemoteAutoCompleteField, RemoteAutoComplete, InputField, Input } from '@components/form';

import * as T from './_dayplansTypes';
import { required } from '@utils/validators';
import { getDayPlan } from './_dayplansActions';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { periodTypeLabel } from '@utils/utils';
import { dayplansPath } from './DayplansGridSingle';

const linkBack = dayplansPath;

const enhance = compose<T.DayplansFormProps, T.DayplansFormProps>(
  withRouter,
  EntityDetailEnhancer<T.DayplansEnhancerProps<T.Calendar>, T.Calendar>({
    getEntity: getDayPlan,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Denní plány', to: linkBack },
    { label: get(entity, 'name', 'Nový denní plán') }
  ]),
  withProps<{}, T.DayplansForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({
    form: 'dayplansGrid'
  }),
  connect(
    state => {
      const values = getFormValues('DayplansGrid')(state);
      return {
        employees: get(values, 'employees')
      };
    },
    {}
  )
);

const renderPeriods = ({ fields }) => (
  <>
    {fields.map((period, index) => (
      <Row key={index}>
        <Col md={4} xl={2}>
          <RemoteAutoCompleteField
            id="type"
            name={`${period}.type`}
            label={`Interval č. ${index + 1}`}
            fullWidth={true}
            component={RemoteAutoComplete}
            url="/metropolis/api/hr/workplan/calendar/period"
            labelFunction={o => (o ? `${periodTypeLabel(get(o, 'type'))}` : undefined)}
            valueFunction={o => get(o, 'type')}
            arrowstyle={{
              color: '#e1e0e1',
              position: 'absolute',
              right: 0,
              top: 32
            }}
          />
        </Col>
        <Col md={4} xl={2}>
          <InputField component={Input} name={`${period}.from`} label="Od" />
        </Col>
        <Col md={4} xl={2}>
          <InputField component={Input} name={`${period}.to`} label="Do" />
        </Col>
      </Row>
    ))}
  </>
);

const View: React.SFC<T.DayplansFormProps> = ({ employees, change, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={4} xl={2} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Základní informace</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RemoteAutoCompleteField
                    id="type"
                    caching={true}
                    name="employee.id"
                    disabled={true}
                    label="Zaměstnanec *"
                    fullWidth={true}
                    component={RemoteAutoComplete}
                    url="/metropolis/api/hr/employees"
                    labelFunction={o => (o ? `${get(o, 'firstName', '')} ${get(o, 'lastName', '')}` : '')}
                    valueFunction={o => get(o, 'id')}
                    validate={[required]}
                    arrowstyle={{
                      color: '#e1e0e1',
                      position: 'absolute',
                      right: 0,
                      top: 32
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="label" label="Název" />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="description" label="Popis" />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h4>Intervaly</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FieldArray<any> name="periods" component={renderPeriods} />
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const DayplansFormSingle = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-dayplans/DayplansFormSingle.tsx